export default "__VITE_ASSET__CFB2kHdr__"